module.exports = __webpack_public_path__ + "img/logo-um-fvv-ang.d9097fc4.png";